import { useEffect, useState } from "react";
import { getBlob } from "./idb";

/**
 * Object URL of a picture still waiting in the outbox (IndexedDB), revoked when it changes. Null once the
 * blob is gone (synced and cleaned up), so the caller falls back to the server URL; undefined while it is
 * still being read, so the caller can wait instead of trying the server for a picture not uploaded yet.
 */
export function useLocalImage(key: string | null | undefined): string | null | undefined {
  const [url, setUrl] = useState<{ key: string; url: string | null } | null>(null);
  useEffect(() => {
    if (!key) return;
    let live = true;
    let made: string | null = null;
    void getBlob(key).then((b) => {
      if (!live) return;
      made = b ? URL.createObjectURL(b) : null;
      setUrl({ key, url: made });
    });
    return () => {
      live = false;
      if (made) URL.revokeObjectURL(made);
    };
  }, [key]);
  if (!key) return null;
  return url?.key === key ? url.url : undefined;
}
